import {
  MAIN_BACKGROUND_1,
  MAIN_CONCERT_INFO,
  MAIN_CONTENT,
} from 'src/assets/database/webData';
import { BOARD_SET_WIDTH_WEB } from 'src/consts/user-web.const';
import { FlexBoxFullWidth } from 'src/styles/OverviewStyle';
import styled from 'styled-components';

export default function WebMainPage() {
  return (
    <BoardMainPage url={MAIN_BACKGROUND_1}>
      <img src={MAIN_CONTENT} alt="" style={{ marginBottom: '260px' }} />
      <GrayDiv>
        <img src={MAIN_CONCERT_INFO} alt="" />
      </GrayDiv>
    </BoardMainPage>
  );
}

const BoardMainPage = styled(FlexBoxFullWidth)<{ url: string }>`
  width: 100%;
  min-height: 100vh;

  background-image: url(${({ url }) => url});
  background-position: center;
  background-size: cover;

  padding: 80px 0 200px 0;

  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

  img {
    width: ${BOARD_SET_WIDTH_WEB}px;
    height: 'auto';
  }
`;

const GrayDiv = styled(FlexBoxFullWidth)`
  width: 100dvw;
  height: auto;

  background-color: rgba(0, 0, 0, 0.5);

  padding: 80px 0 100px 0;

  justify-content: center;
  align-items: center;
`;
